<div class='loader-container' role="status">
  <img src="/assets/images/spinner.svg" [attr.alt]="'ariaContentLoadingLabel' | T"/>
</div>
